<div class="row">
  <div class="createCPPOuter fixHeightMobile">
    <div class="create-cpp-page">
      <div class="order-view-sec breadcrumbOuter padding-0" id="orderView1" [ngClass]="'col-md-12'">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb padding-l0">
            <li class="breadcrumb-item active">
              <a href="javascript:void(0)" (click)="navigateToLandingPage()">Early Advantage Order</a>
              <i class="fas fa-angle-right"></i>
            </li>
            <li class="breadcrumb-item breadcrumbColor xs-pr-0">
              <span *ngIf="webOrderNumber==0">Order Entry</span>
              <span *ngIf="webOrderNumber>0 || webOrderNumber!=null">Web Order # : {{webOrderNumber}}</span>
              <span *ngIf="webOrderNumber==null || webOrderNumber=='' ">Order Entry</span>
            </li>
          </ol>
        </nav>
      </div>
      <!--Crop year and filter section-->
      <div class="OrderReleaseTop">
        <div class="statusNotice">
          <div class="status-bar mb-3 margin-0 margin-b10" style="color: #0b3f54 !important">
            <span class="fontCondBold margin-r20">
              Status Notice:
            </span>
            {{statusNotice}}
          </div>
        </div>
        <!--Ship to - Confirmation Email Section-->
        <div class="section-border">
          <div class="row">
            <!--Sold To Select List-->
            <div class=" col-md-6 material-select withBordr">
              <ng-select name="ddlSoldTo"
                         [items]="soldToFacility"
                         class="custom-select-grower grower-add-drop"
                         [virtualScroll]="true"
                         [(ngModel)]="soldToAccount"
                         bindLabel="accountNameCityState"
                         [disabled]="true"
                         bindValue="accountNumber"
                         placeholder="Sold To:"
                         [loading]="soldToDataLoading"
                         [closeOnSelect]="true"
                         [searchFn]="accountSearchFn">
                <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                  <div class="dropdown-template">
                    <div class="row">
                      <div class="col-md-8">
                        <h4 class="name greenColor" [ngOptionHighlight]="search">
                          {{item.accountName}}
                        </h4>
                        <p class="address" [ngOptionHighlight]="search">
                          {{item.address1}},  {{item.city}}, {{item.state}} - {{item.zipCode}}
                        </p>
                        <p class="phoneNo" [ngOptionHighlight]="search">
                          {{item.primaryPhoneNumber}}
                        </p>
                        <p class="grower-nos">
                          <span class="grower-gln" [ngOptionHighlight]="search">
                            Account #: {{item.accountNumber}}
                          </span>
                        </p>
                      </div>
                    </div>
                  </div>
                </ng-template>
              </ng-select>
            </div>

            <!--Ship To Select List-->
            <div class=" col-md-6 material-select withBordr">
              <ng-select name="ddlShipTo"
                         [items]="shipToFacilityList"
                         class="custom-select-grower grower-add-drop"
                         [virtualScroll]="true"
                         [(ngModel)]="shipToAccount"
                         bindLabel="accountNameCityState"
                         [disabled]="isEditMode || readOnlyAccess"
                         bindValue="accountNumber"
                         placeholder="Ship To:"
                         [loading]="shipToDataLoading"
                         [closeOnSelect]="true"
                         [searchFn]="accountSearchFn"
                         (change)="getShipTo($event)"
                         (clear)="getShipTo($event)">
                <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                  <div class="dropdown-template">
                    <div class="row">
                      <div class="col-md-8">
                        <h4 class="name greenColor" [ngOptionHighlight]="search">
                          {{item.accountName}}
                        </h4>
                        <p class="address" [ngOptionHighlight]="search">
                          {{item.address1}},  {{item.city}}, {{item.state}} - {{item.zipCode}}
                        </p>
                        <p class="phoneNo" [ngOptionHighlight]="search">
                          {{item.primaryPhoneNumber}}
                        </p>
                        <p class="grower-nos">
                          <span class="grower-gln" [ngOptionHighlight]="search">
                            Account #: {{item.accountNumber}}
                          </span>
                        </p>
                      </div>
                    </div>
                  </div>
                </ng-template>
              </ng-select>
            </div>
          </div>

          <div class="row">
            <div class="col-md-12 specialInst padding-t4">
              <mat-form-field class="example-full-width">
                <label class="checkbox-color">Shipping Instructions:</label>
                <textarea style="resize:none;height:auto;" matInput rows="2"
                          (input)="hasHeaderInfoChanged('Special Instructions');"
                          [maxLength]="500"
                          [readonly]="readOnlyAccess"
                          [(ngModel)]="specialInstructionText"></textarea>
              </mat-form-field>
            </div>
          </div>

          <div class="row">
            <div class="col-md-4 purchaseOrder margin-t12">
              <mat-form-field class="wide100">
                <mat-label>Customer PO#:</mat-label>
                <input matInput type="text" name="purchaseOrder" (keypress)="keyPressNumeric($event)"
                       (input)="enablePlaceOrderAndSaveOrderDraft();hasHeaderInfoChanged('PO');"
                       [(ngModel)]="purchaseOrder"
                       [readonly]="readOnlyAccess"
                       autocomplete="off"
                       [maxLength]="14">
              </mat-form-field>
            </div>
            <div class="col-md-4 purchaseOrder margin-t12" *ngIf="isSubscriptionAccess">
              <mat-form-field class="wide100" [ngClass]="{valid : (isNotValid ==false)}">
                <mat-label>Non-Subscriber Email:</mat-label>
                <input matInput type="email" name="accountEmail" maxlength="250"
                       placeholder="(Separate multiple email addresses by a semi-colon)"
                       [(ngModel)]="accountEmail"
                       [readonly]="readOnlyAccess"
                       [pattern]="emailPattern"
                       (blur)="validateEmail()"
                       (input)="hasHeaderInfoChanged('Email Address');"
                       autocomplete="off"
                       email="true">
                <mat-error *ngIf="isNotValid">
                  This is invalid e-mail address(s). Separate multiple email addresses by a semi-colon.
                </mat-error>
              </mat-form-field>
            </div>
          </div>

          <div class="row" *ngIf="isShowPackagedContactDetails">
            <div class=" col-md-4 material-select withBordr updateFontSize">
              <ng-select name="ddlPackagedContactName"
                         [items]="cppPackagedDeliveryInstructionList"
                         class="custom-select-grower grower-add-drop"
                         [(ngModel)]="cppPackagedContactInfo"
                         bindLabel="contactName"
                         bindValue="contactNamePhoneNumber"
                         placeholder="Contact Name:*"
                         [closeOnSelect]="true"
                         [searchFn]="packagedContactNameSearchFn"
                         (change)="getPackagedContactPhone($event)"
                         (clear)="getPackagedContactPhone($event)"
                         data-testid="ddl-packaged-contact-name-search"
                         [addTag]="true"
                         (keypress)="keyPressAlphaNumericWithSpace($event)"
                         [typeahead]="inputPackagedContactName$"
                         (blur)="createNewPackagedContact()">
                <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                  <div *ngIf="item.contactId" class="dropdown-template" [attr.data-testid]="'ddl-packaged-contact-name-option_'+index">
                    <div class="row">
                      <div class="col-md-8">
                        <p class="address" [ngOptionHighlight]="search">
                          {{item.contactName}}
                        </p>
                      </div>
                    </div>
                  </div>
                </ng-template>
              </ng-select>
            </div>
            <div class="col-md-4 purchaseOrder margin-t12" matTooltip={{bulkContactNumberTooltip}} [matTooltipPosition]="'above'" matTooltipClass='gray-tooltip' *ngIf="isShowPackagedContactDetails">
              <mat-form-field class="wide100">
                <mat-label>Contact Phone Number:</mat-label>
                <input matInput type="text" name="packagedContactNumber"
                       (input)="hasHeaderInfoChanged('Bulk Number');enablePlaceOrderAndSaveOrderDraft()"
                       [(ngModel)]="pkgContactNumber"
                       [readonly]="readOnlyAccess"
                       required
                       [maxLength]="10"
                       mask="0000000000"
                       (change)="phoneShouldBeValid(pkgContactNumber)">
                <mat-error *ngIf="isPhoneNotValid">Please enter a 10 digit phone number</mat-error>
              </mat-form-field>
            </div>
            <div class=" col-md-4 material-select withBordr updateFontSize" *ngIf="isShowPackagedContactDetails">
              <ng-select name="ddlDeliveryInstructions"
                         [items]="deliveryInstructionsCodeList"
                         [multiple]="true"
                         class="custom-select-grower grower-add-drop"
                         [(ngModel)]="cppDeliveryInstructionCode"
                         bindLabel="id"
                         bindValue="id"
                         placeholder="Delivery Instructions:"
                         [closeOnSelect]="true"
                         [searchFn]="bulkContactNameSearchFn"
                         data-testid="ddl-delivery-instruction-search">
                <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                  <div class="dropdown-template" [attr.data-testid]="'ddl-delivery-instruction-option_'+index">
                    <div class="row">
                      <div class="col-md-8">
                        <p class="address" [ngOptionHighlight]="search">
                          {{item.value}} ({{item.id}})
                        </p>
                      </div>
                    </div>
                  </div>
                </ng-template>
              </ng-select>
            </div>
          </div>
          <div class="row" *ngIf="isShowBulkContactDetails">
            <div class=" col-md-4 material-select withBordr updateFontSize">
              <ng-select name="ddlBulkContactName"
                         [items]="cppDeliveryInstructionList"
                         class="custom-select-grower grower-add-drop"
                         [(ngModel)]="cppBulkContactInfo"
                         bindLabel="contactName"
                         bindValue="contactNamePhoneNumber"
                         placeholder="Bulk Contact Name:*"
                         [closeOnSelect]="true"
                         [searchFn]="bulkContactNameSearchFn"
                         (change)="getBulkContactPhone($event)"
                         (clear)="getBulkContactPhone($event)"
                         data-testid="ddl-bulk-contact-name-search"
                         [addTag]="true"
                         (keypress)="keyPressAlphaNumericWithSpace($event)"
                         [typeahead]="inputBulkContactName$"
                         (blur)="createNewContact()">
                <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                  <div *ngIf="item.contactId" class="dropdown-template" [attr.data-testid]="'ddl-bulk-contact-name-option_'+index">
                    <div class="row">
                      <div class="col-md-8">
                        <p class="address" [ngOptionHighlight]="search">
                          {{item.contactName}}
                        </p>
                      </div>
                    </div>
                  </div>
                </ng-template>
              </ng-select>
            </div>
            <!--div class="col-md-4 purchaseOrder margin-t12">
              <mat-form-field class="wide100">
                <input matInput type="text"
                       name="contactName"
                       (input)="convertFirstWordToUpperCase(blkContactName);hasHeaderInfoChanged('Bulk Name');enablePlaceOrderAndSaveOrderDraft()"
                       [(ngModel)]="blkContactName"
                       [readonly]="readOnlyAccess"
                       placeholder="Bulk Contact Name:"
                       [maxLength]="30"
                       autocomplete="off"
                       required>
              </mat-form-field>
            </div>-->
            <div class="col-md-4 purchaseOrder margin-t12" matTooltip={{bulkContactNumberTooltip}} [matTooltipPosition]="'above'" matTooltipClass='gray-tooltip'>
              <mat-form-field class="wide100">
                <mat-label>Bulk Contact Phone Number:</mat-label>
                <input matInput type="text" name="contactNumber"
                       (input)="hasHeaderInfoChanged('Bulk Number');enablePlaceOrderAndSaveOrderDraft()"
                       [(ngModel)]="blkContactNumber"
                       [readonly]="readOnlyAccess"
                       required
                       [maxLength]="10"
                       mask="0000000000"
                       (change)="phoneShouldBeValid(blkContactNumber)">
                <mat-error *ngIf="isPhoneNotValid">Please enter a 10 digit phone number</mat-error>
              </mat-form-field>
            </div>
          </div>
        </div>
        <div class="form-sec">
          <div class="row margin-r0 mb-3">
            <div class="col-sm-9 filterRow margin-t15">
              <div class="text-center diclaimermsg">{{this.disclaimerMessage}}</div>
            </div>
            <div class="col-sm-3 text-right">
              <div class="d-flex justify-content-around">
                <div class="margin-t15 d-none d-sm-none d-md-block">
                  <button mat-raised-button class="btns" [disabled]="!isAddProductEnable" (click)="uploadProduct()">Upload Products</button>
                </div>
                <div class="margin-t15 d-none d-sm-none d-md-block">
                  <button mat-raised-button class="btns" [disabled]="!isAddProductEnable" (click)="addProduct()">Add Products</button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div>

          <div class="OrderReleaseDetail">
            <!--Product Detail section-->
            <div class="form-sec">
              <div class="row margin-r0 mb-2">
                <div class="col-sm-9 filterRow">
                  <mat-checkbox #Allcheck class="custom-checkbox select-all-check"
                                [checked]="blanketProductItemsDataSource.data.length > 0 && (selectedCount > 0) && (selectedCount == blanketProductItemsDataSource.data.length)"
                                [indeterminate]="blanketProductItemsDataSource.data.length > 0 && (selectedCount > 0) && (selectedCount < blanketProductItemsDataSource.data.length)"
                                [style.display]="disablecheckbox || readOnlyAccess ? 'none' : ''"
                                (change)="enableAllCheckBoxes(Allcheck._checked);"
                                matTooltip="Select All Lines" [matTooltipPosition]="'above'"></mat-checkbox>

                  <div class="product-tools-outer" *ngIf="showTabs && (!isSearchClicked && editToolKit)">
                    <div class="product-tools-tab" appClickOutside (clickOutside)="tabNode=''">

                      <div class="tab-bar margin-l15 col-md-10">
                        <ul>
                          <li *ngIf="isBulkRequestedColumnShow && isShowBulkRequestedDateCalender" (click)="showTab('delivery')" [ngClass]="{'active': tabNode==='delivery'}" class="seperator" matTooltip="Set Bulk Requested Date" [matTooltipPosition]="'above'">
                            <i class="icon-ico-delivery"></i>
                          </li>
                          <li (click)="showTab('delete')" [ngClass]="{'active': tabNode==='delete'}" class="seperator" matTooltip="Delete Items from Order" [matTooltipPosition]="'above'">
                            <i class="icon-ico-trash"></i>
                          </li>
                        </ul>
                      </div>

                      <div class="tab-content">
                        <div *ngIf="tabNode==='delivery'" class="deliveryDate">

                          <div class="tab-content-detail">
                            <ngb-datepicker [(ngModel)]="datemodel" [dayTemplate]="customDay" [markDisabled]="isDisabled" ngbDatepicker #d="ngbDatepicker"></ngb-datepicker>
                            <ng-template #customDay let-date let-currentMonth="currentMonth" let-selected="selected" let-disabled="disabled" let-focused="focused">
                              <span class="custom-day" [class.focused]="focused"
                                    [class.bg-primary]="selected" [class.hidden]="date.month !== currentMonth" [class.text-muted]="disabled">
                                {{date.day}}
                              </span>
                            </ng-template>
                            <div class="btn-Sec text-center">
                              <button mat-raised-button class="btns normal-large-btn fullWidthBtn" color="primary" (click)="SetAllFields('deliverydate',datemodel)">Save</button>
                            </div>
                          </div>
                        </div>
                        <div *ngIf="tabNode==='delete'" class="delete-product">
                          <div class="tab-content-heading">
                            For: {{shipToAccountName}}
                          </div>
                          <div class="tab-content-detail">
                            <p>Are you sure you want to delete <span> {{selectedCount}} </span> selected Items(s)?</p>
                            <div class="btn-area">
                              <button mat-raised-button class="btns normal-large-btn" color="primary" (click)="SetAllFields('delete',true)">Yes</button>
                              <button mat-raised-button class="btns normal-large-btn" color="primary" (click)="SetAllFields('delete',false)">No</button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-12 productTableOuter">
                <div class="tableContainer table-mobile createOrderTable" id="cppOrderView">
                  <table mat-table #productTable [dataSource]="blanketProductItemsDataSource" multiTemplateDataRows matSort matSortDirection="desc" class="matTables productTable resultTable">
                    <ng-container matColumnDef="{{column}}" *ngFor="let column of displayedColumns">
                      <div *ngIf="column=='checkbox'"><th mat-header-cell *matHeaderCellDef class="checkBoxCol">&nbsp;</th>
                </div>
                <div *ngIf="column=='product'"><th mat-header-cell *matHeaderCellDef class="prodNameBlock">Product </th></div>
                <div *ngIf="column=='flashmsg'"><th mat-header-cell *matHeaderCellDef class="package text-center">&nbsp;</th></div>
                <div *ngIf="column=='viewDetail'"><th mat-header-cell *matHeaderCellDef style="color:white" class="package text-center">View Detail</th></div>
                <div *ngIf="column=='packageSize'"><th mat-header-cell *matHeaderCellDef class="package text-center">Package Size</th></div>
                <div *ngIf="column=='quantity'"><th mat-header-cell *matHeaderCellDef class="quantityBlock text-center">Quantity</th></div>
                <div *ngIf="column=='orderUOM'"><th mat-header-cell *matHeaderCellDef class="orderUOMBlock text-center">Order UOM</th></div>
                <div *ngIf="column=='itemTotal'"><th mat-header-cell *matHeaderCellDef class="itemTotal text-center">Item Total</th></div>
                <div *ngIf="column=='requestedDate'"><th mat-header-cell *matHeaderCellDef class="deliveryDateBlock text-center">Bulk Requested Date</th></div>
                <td mat-cell *matCellDef="let element">
                  <div *ngIf="column=='checkbox'" class="text-center CheckBoxCol d-flex"
                       (click)="showDetails($event, element,column)"
                       matTooltip="Select Product" [matTooltipPosition]="'above'">
                    <div class="mobile-box">
                      <mat-checkbox #SingleCheck class="custom-checkbox"
                                    [style.display]="'contents'"
                                    [disabled]="readOnlyAccess"
                                    (change)="enableCheckBoxSingle(SingleCheck._checked)"
                                    [(ngModel)]="element.isSelected"></mat-checkbox>
                    </div>
                    <div class="mobile-box d-sm-block d-md-none " (click)="selectForFavorite(element)">
                      <span class="favIcon  md-ml-20 xs-mt-0" *ngIf="!readOnlyAccess">
                        <i *ngIf="!element.isFavorite" class="far fa-star"></i>
                        <i *ngIf="element.isFavorite" class="fas fa-star"></i>
                      </span>
                    </div>
                  </div>

                  <div *ngIf="column=='product'" class="dd-flex">
                    <div class="d-block d-sm-block d-md-none xs-large-font">Product</div>
                    <div class="order-info xs-large-font">
                      <p>{{element.itemVendorName}}</p>
                      <p class="grower-name">{{element.itemDescription}}</p>
                      <!-- US 102336 - Hide for now , need to show after change the logic-->
                      <div *ngIf="false">
                        <p><span class="growerUnit" *ngIf="plAccess == true && element.yourPrice!='' && element.yourPrice!=null && element.yourPrice!=0">${{element.yourPrice | number:'1.4-4'}}/{{element.pricingUnitOfMeasure}}</span></p>
                        <p><span class="paymentTerm" *ngIf="plAccess == true && element.paymentTerms!='' && element.paymentTerms!=null && element.paymentTerms!=undefined">{{element.paymentTerms }}</span></p>
                      </div>
                    </div>
                    <span class="favIcon position-relative" *ngIf="element.warningMessage">
                      <i class="warning-icon" mat-raised-button
                         matTooltip="{{element.warningMessage}}"
                         [matTooltipPosition]="'above'" matTooltipClass='red-tooltip'></i>
                    </span>
                    <span *ngIf="element.isBIO" style="vertical-align: top; margin-top: 10px;display: inline-block">
                      <img src="../../../../assets/icon/svg/WU_Bioverified_Green.png" style="width: 30px; height: 30px" matTooltip="Winfield United Bioverified" [matTooltipPosition]="'above'" />
                    </span>
                  </div>

                  <div *ngIf="column=='flashmsg'">
                    <div [ngClass]="{'order-info-outer-flash-message' :((element.itemFlashMsgDesc!='') && (element.itemFlashMsgDesc!=null))}" *ngIf="element.itemFlashMsgDesc!=''">
                      {{element.itemFlashMsgDesc}}
                    </div>
                  </div>

                  <div *ngIf="column=='viewDetail'" (click)="showProductDetails(element);" class="showHideDetails md-pt-0">
                    <a>{{element.isProductDetailDisplayed ? 'Hide Product Details':'View Product Details' }}</a>
                  </div>

                  <div *ngIf="column=='packageSize'" class="measureUnit text-center largeTableTxt mobile-col-set">
                    <div class="d-block d-sm-block d-md-none">Package Size</div>
                    <div class="m-center">{{element.packageSize}}</div>
                  </div>

                  <div *ngIf="column=='quantity'" class="quantityBlock text-center largeTableTxt landscape-miw-101">
                    <div class="d-block d-sm-block d-md-none">QTY</div>
                    <div class="xs-ml-20 md-ml-0">
                      <button *ngIf="!readOnlyAccess" class="plus-minus-btn minusBtn" (click)="orderUnitChange('decrease',element)"> - </button>
                      <input [readonly]="readOnlyAccess" type="text" class="geu-txt unitsText largeTableTxt" (keyup)="quantityTextChange(element)"
                             [(ngModel)]="element.quantity" maxlength="7" NumbersOnly [ngClass]="{'invalid-txt': (element.quantity<=0 || element.quantity=='')}" />
                      <button *ngIf="!readOnlyAccess" class="plus-minus-btn plusBtn" (click)="orderUnitChange('increase',element)"> + </button>
                    </div>
                  </div>

                  <div *ngIf="column=='requestedDate' && element.isValidBulkItem">
                    <div class="d-block d-sm-block d-md-none xs-pt-15">Bulk Requested Date</div>
                    <div class="text-center deliveryDatePicker padding-t10 m-center">
                      <mat-form-field>
                        <input readonly matInput [matDatepicker]="picker" (focus)="picker.open();" [matDatepickerFilter]="dateFilter"
                               [max]="maxDate" [min]="minDate" [(ngModel)]="element.deliveryDate" (dateChange)="validateDate(element, $event)">
                        <mat-datepicker-toggle [disabled]="readOnlyAccess" [attr.data-testid]="'ddl-delivery-date-icon_'+i" matSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-datepicker [disabled]="readOnlyAccess" #picker>
                        </mat-datepicker>
                      </mat-form-field>
                    </div>
                  </div>

                  <div *ngIf="column=='orderUOM'" class="text-center largeTableTxt">
                    <!-- <div class="d-block d-sm-block d-md-none">UOM CA</div> -->
                    {{element.uom}}
                  </div>
                </td>
                </ng-container>
                <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
                <ng-container matColumnDef="expandedDetail">
                  <td mat-cell class="product-details" *matCellDef="let element" [attr.colspan]="displayedColumns.length">
                    <div [style.display]="element.isProductDetailDisplayed ? 'block' : 'none'">
                      <div class="cpp-prod-info mobile-nested-table">
                        <table style="width:100%">
                          <thead>
                            <tr>
                              <th width="10%" class="text-left">Item #</th>
                              <th width="13%">GTIN</th>
                              <th width="13%">Product Line</th>
                              <th width="20%">Active Ingredients</th>
                              <!--<th width="10%">National Price</th>-->
                              <th width="13%">Pallet Quantity</th>
                              <th width="13%">Restricted Use</th>
                              <th width="13%">Non-Returnable</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <th width="10%" class="d-block d-sm-block d-md-none">Item # </th>

                              <td width="10%" class="text-left"><p>{{element.itemNumber}}</p></td>
                              <th width="13%" class="d-block d-sm-block d-md-none"> GTIN </th>
                              <td width="13%"><p>{{element.gtin}}</p></td>
                              <th width="13%" class="d-block d-sm-block d-md-none"> Product Line </th>

                              <td width="13%"><p>{{element.productLine}}</p></td>
                              <th width="20%" class="d-block d-sm-block d-md-none sm-block"> Active Ingredients </th>
                              <td width="20%"><p>{{element.activeIngredient}}</p></td>
                              <!--<th width="10%" class="d-block d-sm-block d-md-none"> National Price </th>-->
                              <!--<td width="10%"><p> {{element.price | number:'1.4-4'}}</p></td>-->
                              <th width="13%" class="d-block d-sm-block d-md-none sm-block">
                                Pallet Quantity
                              </th>

                              <td width="13%"><p>{{element.palletQuantity | number:'1.4-4'}}</p></td>
                              <th width="13%" class="d-block d-sm-block d-md-none"> Restricted Use </th>

                              <td width="13%"><p>{{element.restrictedUse}}</p></td>
                              <th width="13%" class="d-block d-sm-block d-md-none sm-block"> Non-Returnable </th>
                              <td width="13%"><div [ngClass]="{'oval-shape returnable':( element.returnable ==='X')}"> <p>{{element.returnable}}</p></div></td>
                            </tr>
                            <tr *ngIf="element.warningMessage">
                              <td mat-cell class="product-details" colspan="8">
                                <div class="inline-error red-inline-error m-0">
                                  <div class="row">
                                    <div class="error-msg">{{element.warningMessage}}</div>
                                  </div>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                    <div class="inline-error red-inline-error" *ngIf="element.lineErrors.errors.length > 0" id="error_{{element.lineErrors.rowId}}">
                      <div class="row">
                        <div class="col-md-10">
                          <ol class="error-list">
                            <li *ngFor="let err of element.lineErrors.errors">
                              {{err.error}}
                          </ol>
                        </div>
                        <div class="col-md-2 revertToPrev" (click)="revertToPreviousError(element, true)">
                          <span>
                            Revert to Previous.
                            <i class="icon-ico-Reply"></i>
                          </span>
                        </div>
                      </div>
                    </div>
                  </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumns;sticky:true;"></tr>
                <tr mat-row *matRowDef="let element; columns: displayedColumns;"
                    class="example-element-row"
                    [class.example-expanded-row]="expandedElement === element"
                    (click)="expandedElement = expandedElement === element ? null : element"></tr>
                <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>
                </table>
                <div *ngIf="blanketProductItemsDataSource == undefined || blanketProductItemsDataSource?.data.length == 0" class="noDataMsg">
                  <p>No Record Found.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!--Error section on table-->
  <div class="common-error-block cpp-create red-inline-error" *ngIf="showErrorBlock && errorMsgs.length > 0 && errorMsgs[index].errors.length > 0">
    <div class="row">
      <div class="col-2 col-sm-2 col-md-2 padding-r0 errCountOuter">
        <span class="errorCounting">
          {{currentErrorRow}} of {{errorMsgs.length}}
        </span>
      </div>
      <div class="col-10 col-sm-6 col-md-6 padding-l0 ">
        <ol class="errorMsg">
          <li *ngFor="let err of errorMsgs[index].errors; let i=index">
            {{i+1}}. {{err.error}}
          </li>
        </ol>
      </div>
      <div class="col-12 col-sm-4 col-md-4 button-sec text-right">
        <button mat-raised-button class="btns" color="primary" (click)="revertAllChanges()">Revert All Errors</button>
        <button mat-raised-button class="btns" color="primary" *ngIf="errorMsgs && errorMsgs.length>1" (click)="nextError()">Next Error</button>
      </div>
    </div>
  </div>
  <div class="SeedFulfillBtnSec">
    <div class="row padding-l20">
      <div class="col-md-12 mobile-footer" style="display: contents;">
        <button mat-raised-button *ngIf="!readOnlyAccess" class="btns" (click)="placeOrder()" [style.display]="'inline-block'" [disabled]="!isPlaceOrderEnable">Place Order</button>
        <button mat-raised-button *ngIf="!readOnlyAccess" class="btns" (click)="saveDraft()" [style.display]="'inline-block'" [disabled]="!isPlaceOrderEnable">Save Draft</button>
        <!--<button mat-raised-button class="btns" color="primary" (click)="saveDraft()" [disabled]="!isSaveOrderDraftEnable" [style.display]="'inline-block'">Save Draft</button>-->
      </div>
    </div>
  </div>
</div>
